import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const recordOnboardingState = atom<boolean>({
  key: 'recordOnboardingState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
